import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-permission",
  "use": "icon-permission-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-permission\"><defs><style type=\"text/css\"></style></defs><path d=\"M724.032 640v-72H299.904v72H416v288H96V640h116.032V480h256v-84.416H352V96h320v299.584H555.968V480h256v160H928v288H608V640h116.032zM840 728H696v112h144V728z m-512 0H184v112h144V728z m112-544v123.584h144V184H440z\" p-id=\"2764\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol